import DesCreateLibraryComponentViewModel from 'viewmodel/DesCreateLibraryComponentViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCreateLibraryComponent extends DesBaseCatalogAcc {
    constructor() {
        super(DesCreateLibraryComponentViewModel);
    }

    get libraryId() {
        return this.getAttribute('libraryId');
    }

    get parentFolder() {
        return this.getAttribute('parentFolder');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryId: this.libraryId,
            parentFolder: this.parentFolder
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'parentFolder', 'libraryId'];
    }
}

if (!window.customElements.get('des-create-library-component')) {
    window.customElements.define('des-create-library-component', DesCreateLibraryComponent);
}
